import React, { Fragment } from "react"
import DatePicker from "react-datepicker"
import { Col, Row, Form } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

// Define a default UI for filtering
const FilterLayout = props => {
  const { handleSubmit } = props

  const startDateChange = date => {
    props.setStartDate(date)
  }
  const styleBreadcrumnb = {
    position: "absolute",
    left: "47%",
    padding: "10px 0",
  }
  return (
    <Fragment>
      <Row className="mb-4">
        <Breadcrumbs
          title={"Work Reports"}
          breadcrumbItem={"Work Reports"}
          styleBreadcrumnb={styleBreadcrumnb}
        />
        <Col sm="12" className="d-flex justify-content-end mobile_work_filter">
          <Form onSubmit={handleSubmit}>
            <div className="text-sm-end">
              <div className=" d-flex text-sm-end mobile_responsive_filter">
                <div className="mx-2">
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    selected={props.startDate}
                    onChange={startDateChange}
                    className="form-control mb-0 date-icon-back"
                    placeholderText="Select date"
                    maxDate={new Date()}
                  />
                </div>
                <div className="mx-2">
                  <button
                    className="btn btn-primary "
                    type="submit"
                    onClick={handleSubmit}
                  >
                    <i className="bx bx-filter-alt align-middle"></i> Filter
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Col>
      </Row>
    </Fragment>
  )
}

export default FilterLayout
